function initCaseStudiesSlider(section) {
  if (!section || !(section instanceof HTMLElement)) {
    return;
  }
  const swiperElement = section.querySelector('.js-case-studies-slider-swiper');
  if (!swiperElement) {
    return;
  }
  const sliderSpeed = parseInt(swiperElement.dataset.sliderSpeed, 10) || 500;
  console.log('sliderSpeed', sliderSpeed);
  const swiperElementPagination = section.querySelector('.js-swiper-pagination');

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    speed: sliderSpeed,
    autoplay: false,
    pauseOnMouseEnter: true,
    loop: false,
    pagination: {
      el: swiperElementPagination,
      type: 'bullets',
    },
  });
}

window.addEventListener('load', function () {
  const caseStudiesSliderSection = document.querySelector('.js-case-studies-slider');
  if (!caseStudiesSliderSection) {
    return;
  }
  initCaseStudiesSlider(caseStudiesSliderSection);
});